export default {
  tabs: {
    profile: 'Profilo',
    branding: 'Branding',
    domain: 'Dominio',
    earning: 'Guadagno',
    feature_flags: 'Flag funzionalità',
    notification_channels: 'Canali di notifica',
    pricing: 'Prezzi',
    fees: 'Commissioni',
    payments: 'Pagamenti',
    billing: 'Fatturazione',
  },
  earning: {
    internal_notice: 'Impostazioni solo FoodAmigos. Non visibili al partner.',
    read_only_notice: 'Sola lettura. Clicca Modifica per cambiare un valore.',
    editing_notice: 'Modifica in corso — le modifiche influenzano i calcoli dei pagamenti reali.',
  },
  fees: {
    internal_notice:
      'Impostazioni riservate a FoodAmigos. Non visibili al partner, e solo i super admin possono aprire questa scheda. Le modifiche influiscono su quanto viene addebitato ai clienti e su quanto guadagna la piattaforma.',
    read_only_notice: 'Sola lettura. Clicca su Modifica per cambiare qualsiasi valore in questa scheda.',
    editing_notice:
      'In modifica — Salva scrive sia la commissione di servizio sia le tariffe di elaborazione. Le tariffe si applicano dal prossimo addebito in poi; le transazioni precedenti mantengono il margine registrato a loro carico.',
  },
  profile: {
    read_only_notice: 'Sola lettura. Clicca Modifica per cambiare un valore.',
    editing_notice: 'Modifica in corso — il nome visualizzato è visibile ai clienti.',
    form: {
      name: {
        label: 'Nome partner',
        hint: "Il nome legale/dell'ente. Usato internamente e nei documenti di fatturazione.",
      },
      display_name: {
        label: 'Nome visualizzato ai clienti',
        hint: "L'etichetta «Powered by ___» mostrata ai clienti. Usa il nome del partner se lasciato vuoto.",
      },
      admin_email: {
        label: 'Email amministratore',
        hint: "L'account amministratore invitato. Non modificabile qui — contatta il team tecnico per spostare l'account.",
      },
      invoicing_emails: {
        label: 'E-mail per le fatture',
        hint: "Le ricevute delle fatture addebitate a questo partner vengono inviate a ciascuno di questi indirizzi. Lascia vuoto per usare l'e-mail dell'amministratore.",
        placeholder: 'Email amministratore',
      },
      status: {
        label: 'Stato',
        hint: "I partner invitati diventano attivi al primo accesso — l'attivazione manuale salta questo passaggio. La sospensione disattiva tutti gli accessi del team del partner.",
      },
      region: {
        label: 'Regione',
        hint: 'Il paese è fisso. Seleziona uno stato se i ristoranti del partner seguono regole fiscali statali — questo modifica solo i valori predefiniti del partner, non i ristoranti esistenti.',
      },
      messenger_audience: {
        label: 'Chat di supporto',
        hint: 'Chi, sotto questo partner, ha accesso alla chat di supporto FoodAmigos. Lo staff FoodAmigos lo ha sempre. I partner white-label supportano i propri ristoranti, quindi solo i loro admin lo ottengono.',
        options: {
          everyone: 'Tutti, ristoranti inclusi',
          partner_admins: 'Solo admin del partner',
          nobody: 'Nessuno',
        },
      },
      shop_domains: {
        label: 'Domini shop',
        hint: 'Domini principali su cui vengono serviti i negozi dei ristoranti del partner. Il dominio primario è usato per i nuovi marchi. Il partner collega e scollega da sé i propri domini del negozio; la scheda Dominio mostra i loro record DNS.',
      },
    },
    region: {
      whole_country: 'Tutto il paese',
    },
    shop_domains: {
      primary: 'Principale',
      platform_default: 'Predefinito piattaforma',
      empty: 'Nessun dominio shop collegato',
    },
    statuses: {
      invited: 'Invitato',
      active: 'Attivo',
      suspended: 'Sospeso',
    },
    custody: {
      label: 'Elaborazione pagamenti',
      not_configured: 'Non ancora configurato',
      provider: 'Gateway proprio del partner',
      platform: 'FoodAmigos elabora i pagamenti',
      bank_account: {
        set: 'Conto bancario: {{label}} ({{status}})',
        missing: 'Nessun conto bancario per ora. Il partner lo inserisce in Fatturazione partner.',
        statuses: {
          active: 'attivo',
          pending_verification: 'in verifica',
          action_needed: 'azione richiesta',
          errored: 'pagamento non riuscito',
          missing: 'mancante',
        },
      },
      hint: "Deciso dalla configurazione dei pagamenti nella scheda Pagamenti e bloccato una volta salvato un canale. Con l'elaborazione FoodAmigos, la quota di ricavi del partner viene pagata mensilmente.",
      kyc: {
        label: 'Account di pagamento',
        missing: 'Non ancora creato',
        incomplete: 'Verifica incompleta',
        complete: 'Pronto per i pagamenti',
        currently_due: 'Stripe richiede ancora: {{fields}}',
        send_link: 'Invia link di onboarding',
        link_copied: 'Link di onboarding copiato negli appunti: inoltralo al partner. È monouso e ha una scadenza.',
        link_ready: 'Link di onboarding: inoltralo al partner (monouso, con scadenza)',
        link_failed: 'Impossibile creare il link di onboarding.',
      },
    },
    suspend_confirm: {
      title: 'Sospendere questo partner?',
      description:
        'Tutti i membri del team del partner saranno disattivati e le loro sessioni revocate. I loro ristoranti rimarranno attivi.',
    },
  },
  branding: {
    read_only_notice: 'Sola lettura. Clicca Modifica per cambiare un valore.',
    editing_notice: 'Modifica in corso — le modifiche sono visibili sulle superfici white-label del partner.',
    upload: 'Carica logo',
    logo: {
      label: 'Logo',
      hint: 'Mostrato sulle superfici white-label del partner.',
    },
    circle_logo: {
      label: 'Favicon / logo circolare',
      hint: 'Logo quadrato usato come favicon e avatar. Opzionale — può essere rimosso.',
    },
    splash_image: {
      label: 'Immagine di accesso',
      hint: 'Riempie la metà sinistra della pagina di accesso white-label del partner da bordo a bordo (ritaglio cover). Consigliata: composizione verticale, almeno 1200×1200px. Opzionale — può essere rimosso.',
    },
    footer_note: 'Ulteriori opzioni di branding (colori secondari) disponibili prossimamente.',
  },
  revenue_split: {
    title: 'Divisione ricavi',
    description:
      "Imposta la quota del partner su ogni commissione raccolta da FoodAmigos sugli ordini dei ristoranti. Predefinita allo 0% — FoodAmigos trattiene l'intera commissione finché non viene concessa una quota. Pagata ogni ciclo di fatturazione.",
    manage_on_fees: 'Gestisci nella scheda Commissioni',
    split: 'Partner {{partner}}% · FoodAmigos {{platform}}%',
    rows: {
      processing: 'Commissioni di elaborazione',
      gift_card: 'Commissione gift card',
      delivery: 'Commissioni di consegna',
      service_fee: 'Commissione di servizio',
    },
    notes: {
      service_fee:
        "L'importo addebitato ai clienti viene impostato in Controlli tariffa di servizio nella scheda Tariffe.",
    },
  },
  service_fee_controls: {
    title: 'Controlli commissione di servizio',
    description: "Ciò che il partner addebita ai clienti come commissione di servizio sull'ordine.",
    zero_percentage_warning:
      'Una percentuale dello 0% non disabilita la commissione di servizio: le commissioni calcolate sotto il minimo vengono arrotondate per eccesso, quindi ogni ordine viene comunque addebitato almeno il minimo.',
  },
  hard_limits: {
    title: 'Limiti massimi',
    description:
      'Limiti FoodAmigos applicati al salvataggio e al checkout. Nessuna commissione di servizio di questo partner — incluse le sostituzioni per ristorante — può superare questi valori.',
    max_percentage: {
      label: '% commissione di servizio massima',
      help: 'La commissione di servizio del partner non può superare questo valore. Limite piattaforma: 5%.',
    },
    min_amount: {
      label: 'Importo minimo commissione di servizio',
      help: 'I minimi per ristorante non possono essere impostati sotto questo importo.',
    },
    max_amount: {
      label: 'Importo massimo commissione di servizio',
      help: 'Limite assoluto sulla commissione di servizio fissa, indipendentemente dalla percentuale.',
    },
  },
  form: {
    is_service_fee_change_allowed: {
      label: 'Consenti modifica commissione di servizio per ristorante',
      description: 'Permette ai singoli ristoranti del partner di usare una commissione di servizio diversa.',
    },
    service_fee_platform_share: {
      label: 'Quota Foodamigos della commissione di servizio',
    },
    recommended: 'Consigliato: {{value}}',
    service_fee_percentage: {
      label: 'Percentuale commissione di servizio predefinita',
      help: 'Applicata a ciascun ristorante del partner se non sostituita.',
    },
    min_service_fee_amount: {
      label: 'Importo minimo commissione predefinito',
      help: 'Minimo predefinito per ordine — le commissioni calcolate sotto vengono arrotondate per eccesso. I ristoranti possono impostare il proprio entro i limiti FoodAmigos.',
    },
    max_service_fee_amount: {
      label: 'Importo massimo commissione predefinito',
      help: 'Limite predefinito per ordine — i ristoranti possono impostare il proprio entro i limiti FoodAmigos.',
    },
    primary_color: {
      label: 'Colore principale del brand',
    },
    dashboard_subdomain: {
      label: 'Slug di accesso partner',
      hint: 'Slug in minuscolo — identifica il brand del partner nel link di accesso del team (?partner=…).',
      placeholder: 'partner-name',
    },
    login_url: {
      label: 'Link di accesso del team',
      hint: 'Il link usato dal team del partner per raggiungere la pagina di accesso con il proprio brand.',
    },
    file: {
      label: 'Immagine',
    },
  },
  buttons: {
    edit: 'Modifica',
    cancel: 'Annulla',
    save: 'Salva',
  },
  toasts: {
    load_error: 'Impossibile caricare le impostazioni.',
    failed_to_save_changes: 'Salvataggio modifiche non riuscito',
    changes_got_saved: 'Modifiche salvate',
    logo_uploaded: 'Logo caricato',
    logo_upload_failed: 'Caricamento logo non riuscito',
    logo_removed: 'Logo rimosso',
    logo_remove_failed: 'Rimozione logo non riuscita',
    file_too_large: 'File troppo grande. Dimensione massima: {{max}} MB.',
    image_too_narrow: "L'immagine di accesso deve essere larga almeno {{min}}px.",
  },
  notification_channels: {
    master_locked:
      'Il partner master invia per ogni ristorante della piattaforma, quindi i suoi canali non possono essere modificati qui.',
    unavailable: 'I canali di notifica non sono ancora disponibili su questo backend.',
    notice:
      "Impostazione interna. Un partner senza un proprio account Twilio deve restare solo email: altrimenti ogni SMS, messaggio WhatsApp e chiamata vocale passerebbe dall'account Twilio di FoodAmigos.",
    forbidden: 'Solo i super admin possono modificare i canali di notifica.',
    columns: {
      channel: 'Canale',
      status: 'Abilitato',
    },
    channels: {
      email: {
        name: 'Email',
        description: 'Sempre attivo, così il partner e i suoi ristoranti sono sempre raggiungibili.',
      },
      sms: {
        name: 'SMS',
        description: 'Aggiornamenti sugli ordini e codici di accesso agli ospiti via SMS.',
      },
      whatsapp: {
        name: 'WhatsApp',
        description: 'Avvisi ai titolari dei ristoranti e codici di accesso agli ospiti su WhatsApp.',
      },
      voice_call: {
        name: 'Chiamate vocali',
        description: 'Chiamate di promemoria per ordini in sospeso e risposta telefonica.',
      },
      push: {
        name: 'Notifiche push',
        description:
          "Notifiche push agli ospiti e all'app dashboard del titolare. Gli avvisi sul tablet dello staff non sono interessati.",
      },
    },
    toasts: {
      load_error: 'Impossibile caricare i canali di notifica.',
      error: 'Impossibile salvare i canali di notifica.',
      saved: 'Canali di notifica salvati.',
    },
  },
  feature_flags: {
    internal_notice: 'Impostazioni solo FoodAmigos. Non visibili al partner. Le modifiche hanno effetto immediato.',
    read_only:
      "Sola lettura — modificare la fatturazione dei ristoranti richiede un rollout coordinato, non un semplice switch. Contatta l'engineering.",
    forbidden: 'Solo i super admin possono gestire i flag funzionalità dei partner.',
    columns: {
      feature: 'Funzionalità',
      status: 'Stato',
    },
    flags: {
      external_printer: {
        name: 'Stampante ricevute esterna',
        description:
          "L'impostazione predefinita per i ristoranti che questo partner attiva da ora in poi: ogni nuovo ristorante parte con la possibilità di collegare una stampante ricevute di rete all'app del terminale ordini. I ristoranti esistenti mantengono ciò che è impostato nella loro scheda Feature Flags, e ogni ristorante può comunque essere modificato singolarmente lì.",
      },
      plg_onboarding: {
        name: 'Onboarding self-service (PLG)',
        description:
          'Onboarding self-service per il partner: offre a questo partner la pagina guidata Nuovo ristorante e la procedura guidata di onboarding invece della modale classica Aggiungi azienda e dello stepper Inizia, nasconde le funzioni riservate a FoodAmigos e non ancora applicabili per il partner e i suoi ristoranti, e blocca il primo go-live finché non viene concordata una data di lancio. Attivo per ogni nuovo partner.',
      },
      issue_end_customer_receipts: {
        name: 'Fatture per clienti finali',
        description:
          'Permette agli ospiti di richiedere una fattura al checkout e riceverla via email. Disattivo per i nuovi partner; le regole internazionali di formato fattura rendono il supporto oneroso.',
      },
      merchant_billing: {
        name: 'Fatturazione ristoranti',
        description:
          'Fattura i ristoranti del partner tramite la piattaforma. Disattivo significa che regolano fuori dalla piattaforma.',
      },
      cuisine_backfill: {
        name: 'Backfill tipologia cucina',
        description:
          "Consente l'esecuzione del backfill automatico della tipologia di cucina per i ristoranti di questo partner.",
      },
      image_backfill: {
        name: 'Backfill immagini',
        description:
          "Consente l'esecuzione del backfill automatico delle immagini menu per i ristoranti di questo partner.",
      },
      auto_image_generation: {
        name: 'Generazione automatica immagini',
        description: 'Genera immagini menu su richiesta per i ristoranti di questo partner.',
      },
      provider_billing: {
        name: 'Fatturazione partner da Foodamigos',
        description:
          'Include questo partner nel ciclo di fatturazione Foodamigos. Disattivato significa che il partner viene fatturato al di fuori della piattaforma. Attiva anche PayPal (diretto) per i ristoranti di questo partner, con la commissione di servizio applicata su di esso.',
      },
      partner_custom_dashboard_domain: {
        name: 'Dominio dashboard personale',
        description:
          'Consente a questo partner di collegare un proprio dominio per la dashboard, così il suo team e i ristoranti accedono con l’indirizzo del partner. Attivandolo o disattivandolo si modificano tutti i link della dashboard inviati dalla piattaforma per questo partner.',
      },
      partner_custom_shop_domain: {
        name: 'Dominio del negozio proprio',
        description:
          'Consente a questo partner di collegare un proprio dominio per i negozi online dei suoi ristoranti, su cui ogni ristorante riceve il proprio indirizzo. Da attivare un partner alla volta: cambia l’indirizzo usato dai clienti.',
      },
      partner_legal_documents: {
        name: 'Documenti legali del partner',
        description:
          'Genera note legali, informativa privacy e termini per i negozi dei ristoranti di questo partner a partire dai dati legali di ciascun ristorante. Se disattivato, o mentre i dati di un ristorante sono incompleti, i negozi mostrano i documenti standard della piattaforma.',
      },
    },
    toasts: {
      load_error: 'Caricamento dei flag funzionalità non riuscito',
      error: 'Modifica del flag funzionalità non riuscita',
      enabled: 'Funzionalità attivata',
      disabled: 'Funzionalità disattivata',
    },
  },
};
